import { useMutation } from './urqlHooks';

export const REPORT_CLIENT_EXPORT = `
  mutation REPORT_CLIENT_EXPORT($input: ReportClientExportInput!) {
    reportClientExport(input: $input) {
      allowed
      masked
    }
  }
`;

export function useReportClientExport() {
  return useMutation(REPORT_CLIENT_EXPORT);
}
